import React, { useEffect, useState } from 'react';
import '../../styles/Alumni/alumniSection.css';
import { FaGraduationCap, FaShare } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../settings';

export default function AlumniSection({ allAlumni }) {
    const [alumni, setAlumni] = useState(allAlumni);
    const [classYears, setClassYears] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const navigate = useNavigate();

    // 👇️ component will mount
    useEffect(() => {
        let temp_classYears = [];
        if (allAlumni?.length > 0 && Array.isArray(allAlumni)) {
            allAlumni?.forEach((single_alumni) =>
                temp_classYears.push(new Date(single_alumni?.classYear).getFullYear())
            );
        }
        setClassYears([...new Set(temp_classYears).values()]);
        setAlumni(allAlumni);
    }, [allAlumni]);

    // 👇️ handler for searching alumni
    const searchAlumniByClassYear = (year) => {
        setAlumni(allAlumni);
        setSearchValue(year);
        if (year) {
            let filtered_alumni = allAlumni?.filter((item) => item?.classYear?.includes(year));
            let temp_classYears = [];
            setAlumni(filtered_alumni);
            if (filtered_alumni?.length > 0 && Array.isArray(filtered_alumni)) {
                filtered_alumni?.forEach((single_alumni) =>
                    temp_classYears.push(single_alumni?.classYear)
                );
            }
            setClassYears([...new Set(temp_classYears)]);
        } else {
            setAlumni(allAlumni);
        }
    };

    return (
        <div className='alumni-section'>
            <div className='searchBox-container'>
                <input
                    type={'search'}
                    name='search'
                    className='searchBox'
                    placeholder={`search alumni class e.g ${new Date().getFullYear()}`}
                    value={searchValue}
                    onChange={(e) => searchAlumniByClassYear(e.target.value)}
                    onSubmit={(e) => searchAlumniByClassYear(e.target.value)}
                />
            </div>

            {alumni?.length > 0 && classYears?.length > 0 ? (
                <div className='class-cards'>
                    {classYears?.map((item, index) => (
                        <div
                            key={`class-card-#${index}`}
                            className='class-card-container'
                            onClick={() =>
                                navigate(`/alumni/classes/${item}`, {
                                    state: {
                                        alumni: alumni?.filter(
                                            (single_alumni) => single_alumni?.classYear == item
                                        ),
                                        year: item,
                                    },
                                })
                            }
                        >
                            <div className='class-card-top'>
                                <div className='left'>
                                    <FaGraduationCap size={35} />
                                    <span>HIT Alumni</span>
                                </div>
                                <div className='right'>
                                    <FaShare size={25} />
                                </div>
                            </div>
                            <h1>
                                Class of <i style={{ color: 'gold' }}>{item}</i>
                            </h1>
                            <span>
                                {' '}
                                Total:{' '}
                                {
                                    alumni?.filter(
                                        (single_alumni) =>
                                            new Date(single_alumni?.classYear).getFullYear() == item
                                    )?.length
                                }{' '}
                            </span>

                            <div className='alumni-classes-preview-container'>
                                <div className='alumni-classes-preview-items'>
                                    {alumni
                                        ?.filter(
                                            (single_alumni) =>
                                                new Date(single_alumni?.classYear).getFullYear() ==
                                                item
                                        )
                                        ?.slice(0, 5)
                                        ?.map((item, index) => (
                                            <div
                                                key={`alumni-class-preview-item-#${index}`}
                                                className='alumni-classes-preview-item'
                                            >
                                                <div className='alumni-classes-preview-item-img-container'>
                                                    <img
                                                        style={{
                                                            objectFit: 'cover',
                                                            zIndex: index + 1,
                                                            left: `-${3 * index}rem`,
                                                            borderRight: item?.avatar
                                                                ? 'border-right: 0.2rem solid gold'
                                                                : 'none',
                                                        }}
                                                        src={
                                                            item?.avatar
                                                                ? `${BASE_URL}/alumni/uploads/get-profile-pic/${item?.avatar}`
                                                                : require('../../images/profile-pictures/face1.jpg')
                                                        }
                                                        alt=''
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className='empty-class-container'>
                    <h1 className='empty-class-container-text'>
                        No alumni profiles available now.
                    </h1>
                </div>
            )}
        </div>
    );
}
